import { render, staticRenderFns } from "./ArtistFilters.vue?vue&type=template&id=20580088&scoped=true&"
import script from "./ArtistFilters.vue?vue&type=script&lang=js&"
export * from "./ArtistFilters.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/filters.css?vue&type=style&index=0&id=20580088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20580088",
  null
  
)

export default component.exports